export const websiteData = {
  categories: {
    "buttons": [
      {
        name: "Flowchef",
        url: "https://www.flowchef.co/",
        image: "/images/buttons-1.webp",
        code: "https://codepen.io/ThunderFound/pen/QWJBQwo",
      },
      {
        name: "Rednecks",
        url: "https://redneck.media/",
        code: "https://codepen.io/zzznicob/pen/VwqYeXN",
        image: "/images/buttons-2.webp",
        gif: "/images/buttons-2g.webp ",
      },
      {
        name: "Spark",
        url: "https://codepen.io/lucasdellabella/pen/RwMyzRd",
        image: "/images/buttons-3.webp",
        iscodelink: true,
      },
      {
        name: "Vercel",
        url: "https://vercel.com/",
        image: "/images/buttons-4.webp",
      },
      {
        name: "CodePen",
        url: "https://codepen.io/",
        code: "https://codepen.io/Mimsoo/pen/oNvaVXx",
        image: "/images/buttons-5.webp",
      },
      {
        name: "Gumroad",
        url: "https://gumroad.com/",
        code: "https://codepen.io/zzznicob/pen/YzdPwbK",
        image: "/images/buttons-6.webp",
      },
      {
        name: "A_NG_D",
        url: "https://an.gd/",
        image: "/images/buttons-7.webp",
      },
      {
        name: "Sonderegger",
        url: "https://www.sonderegger.ch/en",
        image: "/images/buttons-8.webp",
        code: "https://codepen.io/kalisnetwork/pen/dyQqPzY",
      },
      {
        name: "AM-ARC",
        url: "https://am-arc.com/",
        image: "/images/buttons-9.webp",
      },
      {
        name: "Pierre Louis Design",
        url: "https://pierrelouis.design/",
        image: "/images/buttons-10.webp",
      },
      {
        name: "Blackbox",
        url: "https://www.useblackbox.io/",
        image: "/images/buttons-11.webp",
      },
      {
        name: "DoublePoint",
        url: "https://www.doublepoint.com/",
        image: "/images/buttons-12.webp",
      },
      {
        name: "Threads.com",
        url: "https://threads.com/",
        image: "/images/buttons-13.webp",
        code: "https://codepen.io/kalisnetwork/pen/mdQvoJR",
      },
      {
        name: "Starlight",
        url: "https://www.starlight.money/",
        image: "/images/buttons-14.webp",
        code: "https://codepen.io/dccrhvmv/pen/mdQGgWV",
      },
      {
        name: "Clay",
        url: "https://clay.earth/",
        image: "/images/buttons-15.webp",
        code: "https://codepen.io/kalisnetwork/pen/mdQvgrj",
      },
      {
        name: "Quai Network",
        url: "https://qu.ai/#articles",
        image: "/images/buttons-16.webp",
        gif: "/images/buttons-16g.webp ",
      },
      {
        name: "Cosmos",
        url: "https://www.cosmos.so/",
        image: "/images/buttons-17.webp",
        gif: "/images/buttons-17g.webp ",
        code:"https://codepen.io/stranger1586/full/poGZvmZ"
      },
      {
        name: "Louis Escher",
        url: "https://louisescher.dev/",
        image: "/images/buttons-18.webp",
        gif: "/images/buttons-18g.webp ",
        code: "https://codepen.io/kalisnetwork/pen/jOQQQmj",
      },
      {
        name: "Poppr 1",
        url: "https://www.poppr.be/",
        image: "/images/buttons-19.webp",
        gif: "/images/buttons-19g.webp ",
      },
      {
        name: "Poppr 2",
        url: "https://www.poppr.be/",
        image: "/images/buttons-20.webp",
        gif: "/images/buttons-20g.webp ",
        code: "https://codepen.io/Quiddlee/pen/MWPbKxg",
      },
      {
        name: "Chronicle HQ",
        url: "https://chroniclehq.com/",
        image: "/images/buttons-21.webp",
        gif: "/images/buttons-21g.webp ",
        code: "https://codepen.io/Haaguitos/pen/OJrVZdJ",
      },
      {
        name: "Nuxt",
        url: "https://nuxt.com/",
        image: "/images/buttons-22.webp",
        code: "https://codepen.io/kalisnetwork/pen/ZEmNZzm",
      },
      {
        name: "App Embed",
        url: "https://appembed.netlify.app/#generate",
        image: "/images/buttons-23.webp",
        gif: "/images/buttons-23g.webp",
      },
      {
        name: "Kaploom",
        url: "https://www.kaploom.com/",
        image: "/images/buttons-24.webp",
        gif: "/images/buttons-24g.webp",
      },
      {
        name: "Bolt",
        url: "https://www.bolt.com/",
        image: "/images/buttons-25.webp",
        gif: "/images/buttons-25g.webp",
        code: "https://codepen.io/kalisnetwork/pen/poQQQVJ",
      },
      {
        name: "Studio Kingdom",
        url: "https://studiokingdom.co.kr/en/",
        image: "/images/buttons-26.webp",
        gif: "/images/buttons-26g.webp",
        code: "https://codepen.io/kalisnetwork/pen/oNQQQpo",
      },
      {
        name: "WynnCraft",
        url: "https://wynncraft.com/",
        image: "/images/buttons-27.webp",
        gif: "/images/buttons-27g.webp",
      },
      {
        name: "Shopify Supply",
        url: "https://shopify.supply/",
        image: "/images/buttons-28.webp",
        gif: "/images/buttons-28g.webp",
        code:"https://codepen.io/kalisnetwork/pen/BaGebQK",
      },
      {
        name: "Lunchbox",
        url: "https://lunchbox.io/",
        image: "/images/buttons-29.webp",
        gif: "/images/buttons-29g.webp",
      },
      {
        name: "Corey Donenfeld",
        url: "https://coreydonenfeld.com/",
        image: "/images/buttons-30.webp",
        gif: "/images/buttons-30g.webp",
        code: "https://codepen.io/flvffywvffy/pen/rNoeymB",
      },
      {
        name: "Obys",
        url: "https://obys.agency/",
        image: "/images/buttons-31.webp",
        gif: "/images/buttons-31g.webp",
      },
      {
        name: "Design Charm",
        url: "https://designcharm.co/",
        image: "/images/buttons-32.webp",
        gif: "/images/buttons-32g.webp",
      },
      {
        name: "Inbase",
        url: "https://inbase.me/agency",
        image: "/images/buttons-33.webp",
        gif: "/images/buttons-33g.webp",
        code: "https://codepen.io/AJ-the-looper/pen/ZEPEKpv",
      },
      {
        name: "Cut the Code",
        url: "https://www.cutthecode.com/",
        image: "/images/buttons-34.webp",
        gif: "/images/buttons-34g.webp",
      },
      {
        name: "Method",
        url: "https://method.au/",
        image: "/images/buttons-35.webp",
        gif: "/images/buttons-35g.webp",
        code: "https://codepen.io/mh_jsx/pen/JjxopOW"
      },
      {
        name: "Dinosaur Polo Club",
        url: "https://dinopoloclub.com/",
        image: "/images/buttons-36.webp",
        gif: "/images/buttons-36g.webp",
      },
      {
        name: "Design Me Agency",
        url: "www.designme.agency",
        image: "/images/buttons-37.webp",
        gif: "/images/buttons-37g.webp",
      },
      {
        name: "Fortnite Buttons",
        url: "https://codepen.io/Juxtopposed/pen/yLZmVrW",
        image: "/images/buttons-38.webp",
        gif: "/images/buttons-38g.webp",
        iscodelink: true,
      },
      {
        name: "Glassmorphic iOS Buttons",
        url: "https://codepen.io/Juxtopposed/pen/mdvaezM",
        image: "/images/buttons-39.webp",
        gif: "/images/buttons-39g.webp",
        iscodelink: true,
      },
      {
        name: "Send Potion",
        url: "https://sendpotion.com/",
        image: "/images/buttons-40.webp",
        gif: "/images/buttons-40g.webp",
        code: "https://codepen.io/atulkadyan/pen/QWYOvzO",
      },
      {
        name: "Fancy Glowing Button",
        url: "https://codepen.io/Juxtopposed/pen/JjVXRey",
        image: "/images/buttons-41.webp",
        gif: "/images/buttons-41g.webp",
        iscodelink: true,
      },
    ],

    "border-effects": [
      {
        name: "Raycast",
        url: "https://www.raycast.com/",
        image: "/images/border-effects-1.webp",
        code: "https://codepen.io/da1z/pen/WNLZOzZ",
      },
      {
        name: "Poppr",
        url: "https://www.poppr.be/",
        image: "/images/border-effects-2.webp",
        gif: "/images/border-effects-2g.webp ",
      },
      {
        name: "Nuxt",
        url: "https://nuxt.com/",
        image: "/images/border-effects-3.webp",
        gif: "/images/border-effects-3g.webp ",
      },
      {
        name: "Riot Games",
        url: "https://www.riotgames.com/en",
        image: "/images/border-effects-4.webp",
        gif: "/images/border-effects-4g.webp ",
      },
      {
        name: "Vercel",
        url: "https://vercel.com/pricing",
        image: "/images/border-effects-5.webp",
        gif: "/images/border-effects-5g.webp ",
        code: "https://codepen.io/Juxtopposed/pen/xxQNozB",
      },
      {
        name: "Webflow",
        url: "https://webflow.com/",
        image: "/images/border-effects-6.webp",
        gif: "/images/border-effects-6g.webp ",
      },
    ],

    "cards": [
      {
        name: "Quai Network",
        url: "https://qu.ai/#what-can-you-build",
        image: "/images/cards-1.webp",
      },
      {
        name: "Croma",
        url: "https://wearecroma.it/",
        image: "/images/cards-2.webp",
        code: "https://codepen.io/Baraa-Halabi/pen/eYQopLo",
      },
      {
        name: "Nuxt",
        url: "https://nuxt.com/",
        image: "/images/cards-3.webp",
        gif: "/images/cards-3g.webp ",
      },
      {
        name: "Riot Games",
        url: "https://www.riotgames.com/en",
        image: "/images/cards-4.webp",
        gif: "/images/cards-4g.webp ",
      },
      {
        name: "Camillemormal",
        url: "https://camillemormal.com/",
        image: "/images/cards-5.webp",
        gif: "/images/cards-5g.webp ",
      },
      {
        name: "Cuberto",
        url: "https://hello.cuberto.com/",
        image: "/images/cards-6.webp",
      },
      {
        name: "Stripe",
        url: "https://stripe.com/",
        image: "/images/cards-7.webp",
      },
      {
        name: "Webflow 1",
        url: "https://webflow.com/",
        image: "/images/cards-8.webp",
      },
      {
        name: "Webflow 2",
        url: "https://webflow.com/",
        image: "/images/cards-9.webp",
        gif: "/images/cards-9g.webp",
      },
      {
        name: "Webflow 3",
        url: "https://webflow.com/",
        image: "/images/cards-10.webp",
      },
      {
        name: "Cut the Code 1",
        url: "https://www.cutthecode.com/",
        image: "/images/cards-11.webp",
      },
      {
        name: "Cut the Code 2",
        url: "https://www.cutthecode.com/",
        image: "/images/cards-12.webp",
      },
      {
        name: "Method",
        url: "https://method.au/",
        image: "/images/cards-13.webp",
      },
      {
        name: "Turbo Build",
        url: "https://turbo.build/",
        image: "/images/cards-14.webp",
      },
      {
        name: "CSS Battle",
        url: "https://cssbattle.dev/learn",
        image: "/images/cards-15.webp",
      },
    ],

    "custom-cursor": [
      {
        name: "Rednecks",
        url: "https://redneck.media/",
        image: "/images/cursor-1.webp",
        gif: "/images/cursor-1g.webp ",
      },
      {
        name: "AM-ARC 1",
        url: "https://am-arc.com/",
        image: "/images/cursor-2.webp",
        gif: "/images/cursor-2g.webp ",
      },
      {
        name: "AM-ARC 2",
        url: "https://am-arc.com/",
        image: "/images/cursor-3.webp",
        gif: "/images/cursor-3g.webp ",
      },
      {
        name: "Empathy Experiment",
        url: "https://www.empathyexperiment.com/",
        image: "/images/cursor-4.webp",
        gif: "/images/cursor-4g.webp ",
      },
      {
        name: "DoublePoint",
        url: "https://www.doublepoint.com/",
        image: "/images/cursor-5.webp",
        gif: "/images/cursor-5g.webp ",
      },
      {
        name: "Google Design",
        url: "https://design.google/",
        image: "/images/cursor-6.webp",
        gif: "/images/cursor-6g.webp ",
      },
      {
        name: "Kubota Future Cube",
        url: "https://www.kubota.com/futurecube/",
        image: "/images/cursor-7.webp",
        gif: "/images/cursor-7g.webp ",
      },
      {
        name: "JTB Studios",
        url: "https://www.jtbstudios.com.au/",
        image: "/images/cursor-8.webp",
        gif: "/images/cursor-8g.webp ",
      },
      {
        name: "Yuu Dev",
        url: "https://yuukun.dev/",
        image: "/images/cursor-9.webp",
        gif: "/images/cursor-9g.webp ",
      },
      {
        name: "Kaploom",
        url: "https://www.kaploom.com/",
        image: "/images/cursor-10.webp",
        gif: "/images/cursor-10g.webp ",
      },
      {
        name: "All Gold",
        url: "https://allgold.com/",
        image: "/images/cursor-11.webp",
        gif: "/images/cursor-11g.webp ",
      },
      {
        name: "Looskie",
        url: "https://looskie.com/",
        image: "/images/cursor-12.webp",
      },
      {
        name: "Teamgeek",
        url: "https://www.teamgeek.io/",
        image: "/images/cursor-13.webp",
        gif: "/images/cursor-13g.webp ",
      },
      {
        name: "Cuberto",
        url: "https://cuberto.com/",
        image: "/images/cursor-14.webp",
        gif: "/images/cursor-14g.webp ",
      },
    ],

    "grids": [
      {
        name: "'22 Companies.Tools",
        url: "https://recap.companies.tools/",
        image: "/images/grids-1.webp",
      },
      {
        name: "Realtime Colors",
        url: "https://realtimecolors.com/",
        image: "/images/grids-2.webp",
      },
      {
        name: "Apple iPhone 14",
        url: "https://www.apple.com/iphone-14/",
        image: "/images/grids-3.webp",
      },
      {
        name: "Reflect",
        url: "https://reflect.app/home",
        image: "/images/grids-4.webp",
      },
      {
        name: "Tabulio",
        url: "https://tabulio.com/",
        image: "/images/grids-5.webp",
      },
      {
        name: "LinkTree",
        url: "https://linktr.ee/",
        image: "/images/grids-6.webp",
      },
      {
        name: "Starlight",
        url: "https://www.starlight.money/",
        image: "/images/grids-7.webp",
      },
      {
        name: "Clay",
        url: "https://clay.earth/",
        image: "/images/grids-8.webp",
      },
      {
        name: "Vape",
        url: "https://www.vape.gg/",
        image: "/images/grids-9.webp",
      },
      {
        name: "code.spirit",
        url: "https://old.louisescher.dev/",
        image: "/images/grids-10.webp",
        gif: "/images/grids-10g.webp ",
      },
      {
        name: "Johannes Iilahti",
        url: "https://johannesiilahti.com/",
        image: "/images/grids-11.webp",
      },
      {
        name: "Raycast",
        url: "https://www.raycast.com/",
        image: "/images/grids-12.webp",
      },
      {
        name: "Diagram",
        url: "https://diagram.com/",
        image: "/images/grids-13.webp",
      },
      {
        name: "Bolt",
        url: "https://www.bolt.com/",
        image: "/images/grids-14.webp",
      },
      {
        name: "Railway",
        url: "https://railway.app/careers",
        image: "/images/grids-15.webp",
      },
      {
        name: "Linear",
        url: "https://linear.app/",
        image: "/images/grids-16.webp",
      },
      {
        name: "Colabs",
        url: "https://colabs.com.au/",
        image: "/images/grids-17.webp",
      },
      {
        name: "Webflow",
        url: "https://webflow.com/",
        image: "/images/grids-18.webp",
      },
      {
        name: "Method",
        url: "https://method.au/",
        image: "/images/grids-19.webp",
      },
      {
        name: "Supabase",
        url: "https://supabase.com/",
        image: "/images/grids-20.webp",
      },
    ],

    "hamburger-menu": [
      {
        name: "Croma",
        url: "https://wearecroma.it/",
        image: "/images/hamburger-menu-1.webp",
        gif: "/images/hamburger-menu-1g.webp ",
      },
      {
        name: "Poppr",
        url: "https://www.poppr.be/",
        image: "/images/hamburger-menu-2.webp",
        gif: "/images/hamburger-menu-2g.webp ",
        code: "https://codepen.io/Quiddlee/pen/MWPbKxg",
      },
      {
        name: "Obys",
        url: "https://obys.agency/",
        image: "/images/hamburger-menu-3.webp",
        gif: "/images/hamburger-menu-3g.webp ",
      },
      {
        name: "Alder Brixen",
        url: "https://www.adlerbrixen.com/en",
        image: "/images/hamburger-menu-4.webp",
        gif: "/images/hamburger-menu-4g.webp ",
      },
    ],

    "headers": [
      {
        name: "Patreon",
        url: "https://www.patreon.com/",
        image: "/images/headers-1.webp",
        gif: "/images/headers-1g.webp ",
        code: "https://codepen.io/Juxtopposed/pen/dywQpeN",
      },
      {
        name: "Coffe & Aroma",
        url: "https://aroma-coffee-business-template.webflow.io/",
        image: "/images/headers-2.webp",
      },
      {
        name: "Cut the Code",
        url: "https://www.cutthecode.com/",
        image: "/images/headers-3.webp",
        gif: "/images/headers-3g.webp",
      },
      {
        name: "Angel Rion - Cervi",
        url: "https://www.angelrioncervi.com/work",
        image: "/images/headers-4.webp",
        gif: "/images/headers-4g.webp",
      }
    ],

    "hover-effects": [
      {
        name: "Quai Network",
        url: "https://qu.ai/#articles",
        image: "/images/hover-effects-1.webp",
        gif: "/images/hover-effects-1g.webp ",
      },
      {
        name: "Minh Pham",
        url: "https://minhpham.design/",
        image: "/images/hover-effects-3.webp",
        gif: "/images/hover-effects-3g.webp ",
        code: "https://codepen.io/Juxtopposed/pen/mdQaNbG",
      },
      {
        name: "Cuberto",
        url: "https://cuberto.com/",
        image: "/images/hover-effects-4.webp",
        gif: "/images/hover-effects-4g.webp ",
      },
      {
        name: "Corey Donenfeld",
        url: "https://coreydonenfeld.com/",
        image: "/images/hover-effects-5.webp",
        gif: "/images/hover-effects-5g.webp",
        code: "https://codepen.io/flvffywvffy/pen/rNoeymB",
      },
      {
        name: "Linear",
        url: "https://linear.app/",
        image: "/images/hover-effects-6.webp",
        gif: "/images/hover-effects-6g.webp"
      },
      {
        name: "Unbench",
        url: "https://unbench.us/",
        image: "/images/hover-effects-7.webp",
        gif: "/images/hover-effects-7g.webp"
      },
      {
        name: "Tigermilk",
        url: "https://tigermilkrestaurants.com/en/",
        image: "/images/hover-effects-8.webp",
        gif: "/images/hover-effects-8g.webp"
      },
      {
        name: "Cool Typing Game 1",
        url: "https://cooltypinggame.com/",
        image: "/images/hover-effects-9.webp",
        code: "https://codepen.io/boom123bam/pen/YzBboEJ",
      },
      {
        name: "Cool Typing Game 2",
        url: "https://cooltypinggame.com/",
        image: "/images/hover-effects-10.webp",
        gif: "/images/hover-effects-10g.webp",
        code: "https://codepen.io/boom123bam/pen/Rwvmdmz",
      },
    ],

    "icons": [
      {
        name: "Stripe",
        url: "https://stripe.com/",
        image: "/images/icons-1.webp",
        gif: "/images/icons-1g.webp",
      },
      {
        name: "Resend",
        url: "https://resend.com/",
        image: "/images/icons-2.webp",
      },
      {
        name: "Webflow",
        url: "https://webflow.com/",
        image: "/images/icons-3.webp",
      },
    ],

    "image-effects": [
      {
        name: "Outdated",
        url: "https://outdated.vercel.app/",
        image: "/images/image-effects-1.webp",
        gif: "/images/image-effects-1g.webp ",
      },
      {
        name: "Teamgeek",
        url: "https://www.teamgeek.io/",
        image: "/images/image-effects-2.webp",
        gif: "/images/image-effects-2g.webp ",
        code: "https://codepen.io/Juxtopposed/pen/GRPRPyR"
      },
      {
        name: "Romain Avalle",
        url: "https://www.romainavalle.dev/works",
        image: "/images/image-effects-3.webp",
        gif: "/images/image-effects-3g.webp ",
      },
      {
        name: "Cuberto",
        url: "https://cuberto.com/",
        image: "/images/image-effects-4.webp",
        gif: "/images/image-effects-4g.webp ",
        code: "https://codepen.io/Juxtopposed/pen/VwVoEBr"
      },
      {
        name: "Zajno",
        url: "https://zajno.com/",
        image: "/images/image-effects-5.webp",
        gif: "/images/image-effects-5g.webp ",
        code: "https://codepen.io/Juxtopposed/pen/MWZWpVQ"
      },
      {
        name: "Obys",
        url: "https://obys.agency/",
        image: "/images/image-effects-6.webp",
        gif: "/images/image-effects-6g.webp ",
      },
    ],

    "interactive-elements": [
      {
        name: "Superlist",
        url: "https://www.superlist.com/ ",
        image: "/images/interactive-1.webp",
        gif: "/images/interactive-1g.webp ",
      },
      {
        name: "Thomas Bosc",
        url: "https://thomasbosc.com/",
        image: "/images/interactive-2.webp",
        gif: "/images/interactive-2g.webp ",
        code: "https://codepen.io/danuvip/pen/LYMYbpE"
      },
      {
        name: "Advanced Team",
        url: "https://advanced.team/",
        image: "/images/interactive-3.webp",
        gif: "/images/interactive-3g.webp ",
      },
      {
        name: "Diagram",
        url: "https://diagram.com/",
        image: "/images/interactive-4.webp",
        gif: "/images/interactive-4g.webp ",
        code: "https://codepen.io/Hyperplexed/pen/wvQzbGz",
      },
      {
        name: "Cuberto",
        url: "https://cuberto.com/",
        image: "/images/interactive-5.webp",
        gif: "/images/interactive-5g.webp ",
      },
      {
        name: "Webflow",
        url: "https://webflow.com/",
        image: "/images/interactive-6.webp",
        gif: "/images/interactive-6g.webp ",
      },
      {
        name: "Patreon",
        url: "https://www.patreon.com/",
        image: "/images/interactive-7.webp",
        gif: "/images/interactive-7g.webp ",
      },
      {
        name: "Method 1",
        url: "https://method.au/",
        image: "/images/interactive-8.webp",
        gif: "/images/interactive-8g.webp",
      },
      {
        name: "Method 2",
        url: "https://method.au/",
        image: "/images/interactive-9.webp",
        gif: "/images/interactive-9g.webp",
      },
      {
        name: "Best Things for Everything",
        url: "https://shopping.google.com/m/bestthings/",
        image: "/images/interactive-10.webp",
        gif: "/images/interactive-10g.webp",
      },
      {
        name: "Angel Rion - Cervi",
        url: "https://www.angelrioncervi.com/work",
        image: "/images/interactive-11.webp",
        gif: "/images/interactive-11g.webp",
      },
      {
        name: "Design Me Agency",
        url: "www.designme.agency",
        image: "/images/interactive-12.webp",
        gif: "/images/interactive-12g.webp",
      },
      {
        name: "Dog Studio",
        url: "https://dogstudio.co/",
        image: "/images/interactive-13.webp",
        gif: "/images/interactive-13g.webp",
      },
    ],

    "links": [
      {
        name: "Oaks Lane",
        url: "https://oakslane.ch/en",
        image: "/images/links-1.webp",
        gif: "/images/links-1g.webp",
      },
      {
        name: "Hackernoon",
        url: "https://hackernoon.com/",
        image: "/images/links-2.webp",
        gif: "/images/links-2g.webp",
        code: "https://codepen.io/kalisnetwork/pen/PoxxaBO",
      },
      {
        name: "Realtime Colors",
        url: "https://realtimecolors.com/",
        code: "https://codepen.io/Juxtopposed/pen/poQVrPX",
        image: "/images/links-3.webp",
        gif: "/images/links-3g.webp",
      },
      {
        name: "UBAC Store",
        url: "https://ubac-store.com/en/",
        image: "/images/links-4.webp",
        gif: "/images/links-4g.webp",
        code: "https://codepen.io/kalisnetwork/pen/yLQxNQY",
      },
      {
        name: "Awwwards",
        url: "https://www.awwwards.com/",
        code: "https://codepen.io/zzznicob/pen/vYvEYNe",
        image: "/images/links-5.webp",
        gif: "/images/links-5g.webp",
      },
      {
        name: "JTB Studios",
        url: "https://www.jtbstudios.com.au/",
        code: "https://codepen.io/zzznicob/pen/GRPgKLM",
        image: "/images/links-6.webp",
        gif: "/images/links-6g.webp",
      },
      {
        name: "Mack & Pouya",
        url: "https://mackpouya.webflow.io//",
        image: "/images/links-7.webp",
        gif: "/images/links-7g.webp",
      },
      {
        name: "Poppr",
        url: "https://www.poppr.be/",
        image: "/images/links-8.webp",
        gif: "/images/links-8g.webp",
        code: "https://codepen.io/kalisnetwork/pen/yLQQEyj",
      },
      {
        name: "Cuberto",
        url: "https://www.cuberto.com/",
        image: "/images/links-9.webp",
        gif: "/images/links-9g.webp",
      },
    ],

    "loading-animation": [
      {
        name: "Quai Network",
        url: "https://qu.ai/#articles",
        image: "/images/loading-1.webp",
        gif: "/images/loading-1g.webp ",
      },
      {
        name: "Minh Pham",
        url: "https://minhpham.design/",
        image: "/images/loading-2.webp",
        gif: "/images/loading-2g.webp ",
      },
      {
        name: "Edwardh",
        url: "https://www.edwardh.io/",
        image: "/images/loading-3.webp",
        gif: "/images/loading-3g.webp ",
      },
      {
        name: "Unbench",
        url: "https://unbench.us/",
        image: "/images/loading-4.webp",
        gif: "/images/loading-4g.webp ",
      },
      {
        name: "Obys",
        url: "https://obys.agency/",
        image: "/images/loading-5.webp",
        gif: "/images/loading-5g.webp ",
      },
    ],

    "progress-bar": [
      {
        name: "Kubota Future Cube",
        url: "https://www.kubota.com/futurecube/",
        image: "/images/progress-bar-1.webp",
        gif: "/images/progress-bar-1g.webp ",
      },
      {
        name: "The Boat",
        url: "https://www.sbs.com.au/theboat/",
        image: "/images/progress-bar-2.webp",
        gif: "/images/progress-bar-2g.webp ",
      },
      {
        name: "Thomas Bosc",
        url: "https://thomasbosc.com/",
        image: "/images/progress-bar-3.webp",
        gif: "/images/progress-bar-3g.webp ",
        code: "https://codepen.io/RhysJosmin/pen/jOXWqem",
      },
      {
        name: "Stripe Press",
        url: "https://press.stripe.com/",
        image: "/images/progress-bar-4.webp",
        gif: "/images/progress-bar-4g.webp ",
      },
    ],

    "scroll-effects": [
      {
        name: "Romain Avalle",
        url: "https://www.romainavalle.dev/works",
        image: "/images/scroll-effects-1.webp",
        gif: "/images/scroll-effects-1g.webp",
      },
      {
        name: "Stripe Press",
        url: "https://press.stripe.com/",
        image: "/images/scroll-effects-2.webp",
        gif: "/images/scroll-effects-2g.webp",
      },
      {
        name: "Cuberto",
        url: "https://cuberto.com/",
        image: "/images/scroll-effects-3.webp",
        gif: "/images/scroll-effects-3g.webp",
      },
      {
        name: "Lunchbox",
        url: "https://lunchbox.io/",
        image: "/images/scroll-effects-4.webp",
        gif: "/images/scroll-effects-4g.webp",
      },
      {
        name: "Corey Donenfeld",
        url: "https://coreydonenfeld.com/",
        image: "/images/scroll-effects-5.webp",
        gif: "/images/scroll-effects-5g.webp",
      },
      {
        name: "Database AI",
        url: "https://databass.ai/",
        image: "/images/scroll-effects-6.webp",
        gif: "/images/scroll-effects-6g.webp",
      },
      {
        name: "Unbench",
        url: "https://unbench.us/",
        image: "/images/scroll-effects-7.webp",
        gif: "/images/scroll-effects-7g.webp",
      },
      {
        name: "Dotlinecode",
        url: "https://dotlinecode.com/en/",
        image: "/images/scroll-effects-8.webp",
        gif: "/images/scroll-effects-8g.webp",
      },
      {
        name: "The Browser Company",
        url: "https://thebrowser.company/",
        image: "/images/scroll-effects-9.webp",
        gif: "/images/scroll-effects-9g.webp",
      },
      {
        name: "Cosmos",
        url: "https://www.cosmos.so/",
        image: "/images/scroll-effects-10.webp",
        gif: "/images/scroll-effects-10g.webp",
      },
    ],

    "search": [
      {
        name: "Coffe & Aroma",
        url: "https://aroma-coffee-business-template.webflow.io/",
        image: "/images/search-1.webp",
      },
      {
        name: "Aquerone",
        url: "https://www.aquerone.com/",
        image: "/images/search-2.webp",
      },
      {
        name: "Statskog",
        url: "https://www.statskog.no/statskogmillionen#kart",
        image: "/images/search-3.webp",
      },
    ],

    "text-effects": [
      {
        name: "Quai Network",
        url: "https://www.kubota.com/futurecube/",
        image: "/images/text-effects-1.webp",
        gif: "/images/text-effects-1g.webp ",
      },
      {
        name: "Minh Pham",
        url: "https://minhpham.design/",
        image: "/images/text-effects-2.webp",
        gif: "/images/text-effects-2g.webp ",
        code: "https://codepen.io/Juxtopposed/pen/mdQaNbG",
      },
      {
        name: "Chronicle HQ",
        url: "https://chroniclehq.com/",
        image: "/images/text-effects-3.webp",
        gif: "/images/text-effects-3g.webp ",
      },
      {
        name: "Kaploom",
        url: "https://www.kaploom.com/",
        image: "/images/text-effects-4.webp",
        gif: "/images/text-effects-4g.webp ",
      },
    ],

    "3D": [
      {
        name: "Kubota Future Cube",
        url: "https://www.kubota.com/futurecube/",
        image: "/images/3d-1.webp",
        gif: "/images/3d-1g.webp",
      },
      {
        name: "Thomas Bosc",
        url: "https://thomasbosc.com/",
        image: "/images/3d-2.webp",
        gif: "/images/3d-2g.webp ",
      },
      {
        name: "Active Theory",
        url: "https://activetheory.com/",
        image: "/images/3d-3.webp",
        gif: "/images/3d-3g.webp ",
      },
      {
        name: "Joshua's World",
        url: "https://www.joshuas.world/",
        image: "/images/3d-4.webp",
        gif: "/images/3d-4g.webp",
      },
      {
        name: "Stripe Press",
        url: "https://press.stripe.com/",
        image: "/images/3d-5.webp",
        gif: "/images/3d-5g.webp ",
        code:"https://codepen.io/stranger1586/full/JojmzMx"
      },
      {
        name: "Dotlinecode",
        url: "https://dotlinecode.com/",
        image: "/images/3d-6.webp",
      },
      {
        name: "Resend",
        url: "https://resend.com/",
        image: "/images/3d-7.webp",
        gif: "/images/3d-7g.webp ",
      },
      {
        name: "Resend",
        url: "https://resend.com/",
        image: "/images/3d-8.webp",
        code:"https://codepen.io/stranger1586/full/RwvjmdW"
      },
      {
        name: "Cosmos",
        url: "https://www.cosmos.so/",
        image: "/images/3d-9.webp",
        gif: "/images/3d-9g.webp",
        code:"https://codepen.io/stranger1586/full/dyajPro"
      },
      {
        name: "Webflow",
        url: "https://webflow.com/",
        image: "/images/3d-10.webp",
        gif: "/images/3d-10g.webp ",
      },
    ],
  },
};
